<template>
  <div class="effects-layer">
    <div ref="rainContainer" class="rain-container" :class="{ active: currentEffect === 'rain' }"></div>
    <div ref="snowContainer" class="snow-container" :class="{ active: currentEffect === 'snow' }"></div>
    <div ref="starsContainer" class="stars-container" :class="{ active: currentEffect === 'stars' }"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useEffects } from '@/composables/useEffects.js'

export default {
  name: 'EffectsLayer',
  props: {
    currentEffect: {
      type: String,
      default: null
    }
  },
  emits: ['effectToggled'],
  setup(props, { emit }) {
    const rainContainer = ref(null)
    const snowContainer = ref(null)
    const starsContainer = ref(null)
    
    const { initEffects, toggleEffect, currentEffect: effectsCurrentEffect } = useEffects()
    
    onMounted(() => {
      initEffects(starsContainer.value)
    })
    
    const handleToggleEffect = (effectName) => {
      const containers = {
        rain: rainContainer.value,
        snow: snowContainer.value,
        stars: starsContainer.value
      }
      toggleEffect(effectName, containers)
      emit('effectToggled', effectsCurrentEffect.value)
    }
    
    // 暴露方法给父组件
    const toggleEffectExternal = (effectName) => {
      handleToggleEffect(effectName)
    }
    
    return {
      rainContainer,
      snowContainer,
      starsContainer,
      toggleEffectExternal
    }
  }
}
</script>

<style scoped>
.effects-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5;
}

.rain-container,
.snow-container,
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease;
  overflow: hidden;
}

.rain-container.active,
.snow-container.active,
.stars-container.active {
  opacity: 1;
}

/* 雨滴样式 */
:deep(.raindrop) {
  position: absolute;
  width: 2px;
  height: 20px;
  background: linear-gradient(to bottom, rgba(255,255,255,0.8), rgba(255,255,255,0.2));
  border-radius: 1px;
  animation: rainFall linear infinite;
}

@keyframes rainFall {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100vh + 30px));
    opacity: 0;
  }
}

/* 雪花样式 */
:deep(.snowflake) {
  position: absolute;
  color: rgba(255, 255, 255, 0.8);
  user-select: none;
  pointer-events: none;
  animation: snowFall linear infinite;
  font-size: 1rem;
}

@keyframes snowFall {
  0% {
    transform: translateY(-30px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100vh + 30px)) rotate(360deg);
    opacity: 0;
  }
}

/* 星星样式 */
:deep(.star) {
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  border-radius: 50%;
  animation: twinkle 2s infinite alternate;
}

:deep(.star.large) {
  width: 3px;
  height: 3px;
  animation-duration: 3s;
}

:deep(.star.small) {
  width: 1px;
  height: 1px;
  animation-duration: 1s;
}

@keyframes twinkle {
  0% { opacity: 0.3; }
  100% { opacity: 1; }
}
</style>